import React from "react";
import { Info } from "@material-ui/icons";
import useStyles from "./styles";

export default function TooltipIcon({
  className,
  disabled,
}: {
  className?: string;
  disabled?: boolean;
}) {
  const { icon } = useStyles({ disabled });
  return <Info className={`${icon} ${className}`} />;
}
